module.exports = __webpack_public_path__ + "static/img/sence2.e38a5c2.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/feature6/sence2.png
// module id = cFkL
// module chunks = 7